export const downloadFile = (url: string = '', name?: string, target = '') => {
  const a = document.createElement('a')
  const fileName = name ?? url.split('?')[0].split('/').pop() ?? ''

  a.setAttribute('href', url)
  a.setAttribute('download', fileName)
  if (target) {
    a.setAttribute('target', target)
  }

  a.click()
  a.remove()
}

export function openUsdz(url: string) {
  console.info('Attempting to open USDZ file:', url)
  const anchor = document.createElement('a')
  if (anchor.relList && anchor.relList.supports('ar')) {
    console.info('AR Quick Look is available.')
    anchor.href = url
    anchor.rel = 'ar'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)
  } else {
    console.info('AR Quick Look is not available or not supported by this browser.')
  }
}
